import { Suspense, lazy, useEffect, useState } from "react";
import { withAppContext } from "src/store/initAppContext";
import React, { PureComponent } from 'react';
import { theme, withProp } from 'styled-tools';
import styled, { withTheme } from 'styled-components'
import { MetaProps, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { tncPagesSEOData } from "src/config/seo_api";

interface IProps {
    app: {
        brandId: number;
    };
	theme: any;
}

const KycPolicy: React.SFC<IProps> = props => {
	const { app: { brandId }, theme } = props
	const { config: { showOnlyOnFomo, showAPISEOData } } = theme;
	const [seoObjects, setseoObjects] = useState({} as MetaProps);

	//for SEO
	useEffect(() => {
		if (showAPISEOData) {
			const getSeoData = tncPagesSEOData();
			const pathName = "/about/kyc-policy";

			getSeoData.then(resp => {
				const { objects } = resp;
				const seoData = objects.find((obj: any) => {
					const { metadata = {} } = obj;
					if (metadata.pathname && metadata.pathname === pathName) {
						return obj;
					}

				}) || {};

				const { metadata = {} } = seoData;
				setseoObjects(metadata);

			}).catch(error => console.log(`[${pathName}]:Error in SEO API`))
		}

	}, []);


    const Contents = brandId && brandId === 32 ? lazy(() => import("src/components/fine_print/kyc32")) : 
	brandId && showOnlyOnFomo ? lazy(() => import("src/components/fine_print/kyc39")) : 
	brandId && (brandId === 46 || brandId === 47) ? lazy(() => import("src/components/fine_print/kycFun88")) : 
	brandId && (brandId === 61) ? lazy(() => import("src/components/fine_print/kyc61")) : 
	lazy(() => import("src/components/fine_print/kyc31"))

	return (
		<>
			{showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

			<ContentWrapper>
				<Suspense fallback={<div>Loading ... </div>}>
					<Contents />
				</Suspense>
			</ContentWrapper>
		</>
	);
};

export default withTheme(withAppContext(KycPolicy));


const ContentWrapper = styled.div`
	max-width: 800px;
	margin: 0 auto;
	font-size: 12px;
	padding: 1.5em 1.25em;
    color: white;
    text-transform: capitalize;
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		margin-top: 1.23em;
	}

	h1 {
		font-size: 18px;
        /* color: #f4a322; */
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

	h2 {
		font-size: 16px;
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
	}

	h3 {
		font-size: 14px;
	}

	ul ul,
	ol {
		margin: 1em 0;
	}

	li {
		margin: 0.75em 0;
	}

	a {
		/* color: #e9d967; */
		color: ${theme('palette.seoContenAccordionInnerAngerTagColor')};
		text-decoration: underline;
        cursor: pointer;
	}

	.policyInternWrap {
		position: relative;
		color: ${theme('palette.nametext')};

		.tittle {
			padding-bottom: 10px;
			margin-bottom: 0;
			border-bottom: 1px solid #876329;
		}
	}
`;